<template>
  <div class="ck-upload-local">
    <el-dialog :close-on-click-modal="false"   :visible.sync="ckData.visible" title="多图上传" width="60%">
      <div style="margin: 20px 0px">
        <!--                <el-upload class="upload-local" drag-->
        <!--                        action="https://jsonplaceholder.typicode.com/posts/"-->
        <!--                        multiple>-->
        <!--                    <i class="el-icon-upload"></i><br/>-->
        <!--                    <el-button type="primary" size="small">点击上传</el-button><br/>-->
        <!--                    <span style="font-size: 18px;color: #c5c3c3">或将图片拖到这里</span>-->
        <!--                </el-upload>-->
        <el-upload
          style="padding-left: 20px;width: 100%"
          multiple
          :file-list="fileList"
          action="#"
          :http-request="requestUpload"
          :show-file-list="false"
        >
          <el-row type="flex">
            <el-col :span="4"
              ><el-button size="small" type="primary"
                >点击上传</el-button
              ></el-col
            >
            <el-col :span="20">
              <div class="el-upload__tip">
                <div slot="tip" style="display: flex;">
                  <div
                    style="width:40px;text-align: center;background-color: #009999;margin-right: 10px;color: white"
                  >
                    <span>说明</span>
                  </div>
                  <div>
                    <span>点击图片拖动，即可调整图片顺序!</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-upload>
        <div class="img-list">
          <draggable :animation="200" :list="imgUrls">
            <transition-group style="display: flow-root">
              <li
                class="prop-list"
                v-for="(url, index) in imgUrls"
                :key="index"
              >
                <div class="img-div">
                  <div class="img-del-btn">
                    <el-button type="text" @click="removeImg(index)"
                      ><svg-icon icon-class="delete"
                    /></el-button>
                  </div>
                  <el-image :src="url" fit="contain"></el-image>
                </div>
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>
      <div class="pic-setting">
        <el-row type="flex">
          <el-col :span="4"><span class="setting-name">图片大小</span></el-col>
          <el-col :span="20">
            宽：<el-input
              v-model.number="settings.width"
              size="small"
              style="width: 150px"
            ></el-input
            ><span class="setting-tip"
              >根据已设置的图片宽度,等比例缩放高度</span
            >
          </el-col>
        </el-row>
        <!--                <el-row type="flex">-->
        <!--                    <el-col :span="4"><span class="setting-name">文字环绕</span></el-col>-->
        <!--                    <el-col :span="20">-->
        <!--                        <el-radio-group v-model="settings.around">-->
        <!--                            <el-radio label="1">上下</el-radio>-->
        <!--                            <el-radio label="2">环绕</el-radio>-->
        <!--                        </el-radio-group>-->
        <!--                    </el-col>-->
        <!--                </el-row>-->
        <el-row type="flex">
          <el-col :span="4"><span class="setting-name">对齐方式</span></el-col>
          <el-col :span="20">
            <el-radio-group v-model="settings.align">
              <el-radio label="left">左对齐</el-radio>
              <el-radio label="center">居中对齐</el-radio>
              <el-radio label="right">右对齐</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="ckData.visible = false">取消</el-button>
        <el-button type="primary" size="small" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { uploadImg } from "@/api/product/common"
import { getOSSToken } from "@/api/setting"

export default {
  name: "localUpload",
  props: {
    ckData: {
      type: Object,
      default: function() {
        return {
          visible: false,
          editor: null,
        }
      },
    },
  },
  components: { draggable },
  data() {
    return {
      fileList: [],
      imgUrls: [],
      settings: {
        width: null, //宽度
        around: "1", //环绕方式
        align: "left", //对齐方式
      },
      aliyunOssToken: {},
    }
  },
  computed: {
    nginx() {
      return this.$store.state.setting.nginx
    },
  },
  methods: {
    async requestUpload(data) {
      let _self = this
      let formData = new FormData()
      // formData.append("imageFile", data.file)
      // uploadImg(formData)
      //   .then((res) => {
      //     if (res.code == 200) {
      //       that.msgSuccess("图片上传成功")
      //       //此处localhost:8085对应nxinx的ip和监听端口
      //       that.imgUrls.push(that.nginx + res.imgUrl)
      //     }
      //   })
      //   .catch((err) => {})
      await this.getToken()
      var getSuffix = function(fileName) {
        var pos = fileName.lastIndexOf(".")
        var suffix = ""
        if (pos != -1) {
          suffix = fileName.substring(pos)
        }
        return suffix
      }

      var file = data.file
      if (file.length == 0) {
        alert("请选择文件")
      }

      var filename = new Date().getTime() + getSuffix(file.name)

      //注意formData里append添加的键的大小写
      formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
      formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
      formData.append("policy", _self.aliyunOssToken.policy) //policy
      formData.append("Signature", _self.aliyunOssToken.signature) //签名
      //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

      formData.append("file", file)
      formData.append("success_action_status", 200) //成功后返回的操作码

      var url = _self.aliyunOssToken.host
      var fileUrl =
        _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        // async: false,
        cache: false,
        contentType: false,
        processData: false,
        success: function(data) {
          _self.msgSuccess("图片上传成功")
          _self.imgUrls.push(fileUrl)
        },
        error: function(data) {
          $("#fileUpload").val(null)
        },
      })
    },
    removeImg(index) {
      this.imgUrls.splice(index, 1)
    },
    getToken() {
      var _self = this
      return new Promise(resolve => {
        getOSSToken()
          .then(function(res) {
            if (res.code == 200) {
              _self.aliyunOssToken = res.data
              resolve(res.data)
            } else {
              _self.$message.error(res.msg)
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      })
    },
    submit() {
      let editor = this.ckData.editor
      let around = this.settings.around
      let align = this.settings.align
      let width = this.settings.width
      let element = CKEDITOR.dom.element.createFromHtml("<p/>")
      this.imgUrls.forEach((url) => {
        const p = CKEDITOR.dom.element.createFromHtml("<p/>")
        p.setStyles({ margin: 0, display: "block", width: "100%" })
        p.setStyle("text-align", align)
        const imgHtml = CKEDITOR.dom.element.createFromHtml("<img/>")
        imgHtml.setAttribute("src", url)
        imgHtml.setAttribute("width", width)
        imgHtml.setStyles({ "object-fit": "contain" })
        imgHtml.appendTo(p)
        p.appendTo(element)
      })
      editor.insertElement(element)
      this.ckData.visible = false
    },
  },
}
</script>

<style scoped></style>
